import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import ChevronRight from '@mui/icons-material/ChevronRight';
//   useTheme

const ParametersLegend = ({ scoringParameters }) => {
  //   const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
        Scoring Parameters Legend
      </Typography>
      <Box
        sx={{
          mb: 2,
          p: 2,
          bgcolor: 'rgba(0, 118, 255, 0.05)',
          borderRadius: 1,
          borderLeft: '4px solid',
          borderColor: 'primary.main'
        }}
      >
        <Typography component="span" variant="subtitle1" sx={{ fontWeight: 700, color: 'primary.main', display: 'block', mb: 1 }}>
          <strong>💡 What is this legend for?</strong>
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <ChevronRight sx={{ color: 'primary.main', fontSize: 20, mt: 0.3 }} />
          <Typography variant="body1">
            <strong>Understand the scoring:</strong> Each parameter is rated from 1 (low) to 5 (high) based on clear, objective criteria.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <ChevronRight sx={{ color: 'primary.main', fontSize: 20, mt: 0.3 }} />
          <Typography variant="body1">
            <strong>Compare companies consistently:</strong> These definitions ensure fair, apples-to-apples comparisons across all vendors
            in the report.
          </Typography>
        </Box>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': {
              py: 0.5,
              px: 1,
              fontSize: '0.75rem'
            }
          }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: 'background.default' }}>
              <TableCell sx={{ fontWeight: 'bold', width: '180px' }}>Parameter</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>1 - Low</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>3 - Medium</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>5 - High</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scoringParameters.map((param) => (
              <TableRow key={param.id} sx={{ '&:nth-of-type(odd)': { bgcolor: 'action.hover' } }}>
                <TableCell sx={{ fontWeight: 'medium' }}>
                  {param.id
                    .split('_')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </TableCell>
                <TableCell sx={{ color: 'text.secondary' }}>{param['1']}</TableCell>
                <TableCell sx={{ color: 'text.secondary' }}>{param['3']}</TableCell>
                <TableCell sx={{ color: 'success.main' }}>{param['5']}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ParametersLegend;
